import React, { useEffect, useState } from 'react'
import Menu from "../Menu";
import Pagination from "../components/Pagination";

const History = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataLimit, setDataLimit] = useState(100);
  const [count, setCount] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [totalItems, setTotalItems] = useState(0);
  const [messageDialogOpen, setMessageDialogOpen] = useState(false);
  const [messageDialogContent, setMessageDialogContent] = useState('');

  // UI helpers
  const formatDate = (value) => {
    if (!value) return '';
    try {
      const d = new Date(value);
      if (isNaN(d.getTime())) return value;
      return d.toLocaleString();
    } catch (_) {
      return value;
    }
  };


  const token = getCookie("token") || getCookie("authToken");
  const userid = getCookie("userid") || getCookie("userId");

  const baseURL = 'https://api.dqr-display-tms.bonrix.in/api/ApiHistoryOperation';

  const buildPayload = () => {
    return {
      ispageload: false,
      pagesize: Number(dataLimit),
      currentpageno: Number(count),
      withoutpagination: false,
      pagedirection: 'frist'
    };
  };

  const fetchQueue = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${baseURL}/Search`, {
        method: 'POST',
        headers: {
          accept: 'text/plain',
          'Content-Type': 'application/json-patch+json',
          UserId: userid,
          'X-Authorization': token,
        },
        body: JSON.stringify(buildPayload()),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const rows = Array.isArray(data?.data) ? data.data : [];
      setItems(rows);
      setHasMore(rows.length === Number(dataLimit));
      const approximateTotal = (count * Number(dataLimit)) + rows.length + (rows.length === Number(dataLimit) ? Number(dataLimit) : 0);
      setTotalItems(approximateTotal);
    } catch (err) {
      setError('Failed to fetch history data: ' + err.message);
      console.error('Error fetching history data:', err);
    } finally {
      setLoading(false);
    }
  };




  useEffect(() => {
    fetchQueue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count, dataLimit]);

  const handlePageChange = (page) => {
    setCount(page - 1);
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setDataLimit(newItemsPerPage);
    setCount(0);
  };

  const totalPages = hasMore ? count + 2 : count + 1;

  const openMessageDialog = (message) => {
    let formatted = '';
    try {
      const parsed = typeof message === 'string' ? JSON.parse(message) : message;
      formatted = JSON.stringify(parsed, null, 2);
    } catch (_) {
      formatted = String(message ?? '');
    }
    setMessageDialogContent(formatted);
    setMessageDialogOpen(true);
  };

  const closeMessageDialog = () => {
    setMessageDialogOpen(false);
    setMessageDialogContent('');
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
        <section className="content-header">
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center w-100">
                <h1 className="mb-0">History</h1>
              </div>
            </div>
          </section>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  
                  <div className="card-body">
                    {error && (
                      <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        {error}
                        <button type="button" className="close" onClick={() => setError(null)}>
                          <span>&times;</span>
                        </button>
                      </div>
                    )}


                    {loading && (
                      <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                        <p className="mt-2 text-muted">Loading history data...</p>
                      </div>
                    )}

                    {!loading && items.length === 0 && !error && (
                      <div className="alert alert-info">
                        <i className="fas fa-info-circle mr-2"></i>No history items found.
                      </div>
                    )}

                    {/* Summary */}
                    {!loading && items.length > 0 && (
                      <div className="mb-3">
                        <div>
                          <span className="badge badge-primary mr-2 p-2">Total Records: {items.length}</span>
                        </div>
                      </div>
                    )}

                    {!loading && items.length > 0 && (
                      <>
                        <div className="table-responsive">
                          <table className="table table-sm table-bordered table-striped table-hover">
                             <thead className="thead-light" style={{
                            backgroundColor: 'var(--surface2)',
                            color: 'var(--text)',
                            borderColor: 'var(--border)'
                          }}>
                              <tr className="text-nowrap">
                                <th>ID</th>
                                <th>Created Date</th>
                                <th>IP Address</th>
                                <th>POS ID</th>
                                <th>POS Name</th>
                                <th>Merchant ID</th>
                                <th>Status</th>
                                <th>Message</th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {items.map((row) => (
                                <tr key={row.id}>
                                  <td>{row.id}</td>
                                  <td className="text-nowrap">{formatDate(row.createddate)}</td>
                                  <td>{row.ip || '-'}</td>
                                  <td>{row.posid || '-'}</td>
                                  <td>{row.posname || '-'}</td>
                                  <td>{row.merchantid || '-'}</td>
                                  <td>
                                    <span className={`badge badge-${row.status === 'queue' ? 'warning' : row.status === 'init' ? 'info' : 'secondary'}`}>
                                      {row.status || '-'}
                                    </span>
                                  </td>
                                  <td>
                                    {row.msg ? (
                                      <button 
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={() => openMessageDialog(row.msg)}
                                        title="View message details"
                                      >
                                        <i className="fas fa-eye mr-1"></i>View
                                      </button>
                                    ) : (
                                      <span>-</span>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        <Pagination
                          currentPage={count + 1}
                          totalPages={totalPages}
                          onPageChange={handlePageChange}
                          itemsPerPage={dataLimit}
                          onItemsPerPageChange={handleItemsPerPageChange}
                          totalItems={totalItems}
                          showPageNumbers={false}
                          showItemsPerPageSelector={true}
                        />
                      </>

                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Message Dialog */}
      {messageDialogOpen && (
        <div className="modal" style={{display:'block', background:'rgba(0,0,0,0.5)', overflowY: 'auto'}}>
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="fas fa-envelope mr-2"></i>Message Details
                </h5>
                <button type="button" className="close" onClick={closeMessageDialog}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{maxHeight:'70vh', overflow:'auto', background:'var(--surface)'}}>
                <pre style={{whiteSpace:'pre-wrap', wordBreak:'break-word', margin:0, padding: '15px', background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '12px', color: 'var(--text)'}}>{messageDialogContent}</pre>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeMessageDialog}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </>
  );
};

export default History;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}